// extracted by mini-css-extract-plugin
module.exports = {"balcony":"Balcony_balcony__paU09"};